const Placeholder = ({ height = 15 }) => {
  return <div style={{ height: `${height}px` }}></div>;
};

export default Placeholder;
